import { render, staticRenderFns } from "./InstagramFixed.vue?vue&type=template&id=2ff7e461&scoped=true&"
import script from "./InstagramFixed.vue?vue&type=script&lang=js&"
export * from "./InstagramFixed.vue?vue&type=script&lang=js&"
import style0 from "./InstagramFixed.vue?vue&type=style&index=0&id=2ff7e461&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff7e461",
  null
  
)

export default component.exports